import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-map-not-available-modal',
  templateUrl: './map-not-available-modal.component.html',
  styleUrls: ['./map-not-available-modal.component.css']
})
export class MapNotAvailableModalComponent implements OnInit {
  title: any
  message: any
  constructor(private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any, private router: Router,) {
    //
  }

  ngOnInit(): void {
    this.title = this.data.title
    this.message = this.data.message
  }

  backToDashboard(): void {
    this.dialog.closeAll();
    // this.router.navigate(['/', 'dashboard']);
  }
}
